import { render } from "./FinalEvaluation.vue?vue&type=template&id=b79022f0&scoped=true"
import script from "./FinalEvaluation.vue?vue&type=script&lang=js"
export * from "./FinalEvaluation.vue?vue&type=script&lang=js"

import "./final-evaluation.scss?vue&type=style&index=0&id=b79022f0&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b79022f0"]])

export default __exports__